import React from 'react';

import DetailPageHeader from '../components/detail-page-header';

function ReportContainer(): React.ReactElement {
  return (
    <>
      <DetailPageHeader title="Report" />
    </>
  );
}

export default ReportContainer;
